"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const _1 = require("../.");
/**
 * A button component to trigger form submit action. Cane also uti or reset.
 */
const SubmitButton = ({ onClick = () => { }, reset, loading, suppressErrorMessage, children, }) => {
    const submit = (0, _1.useSubmit)(suppressErrorMessage);
    return (react_1.default.createElement(_1.Button, { onClick: (e) => submit(e, onClick, reset), loading: loading }, children));
};
exports.default = SubmitButton;
